import type { IHttpClient } from '@wix/yoshi-flow-editor';
import { listSections, getSection } from '@wix/ambassador-restaurants-menus-v1-section/http';
import type { ErrorHandlerPublicAPI } from '@wix/error-handler';
import type { Section } from 'root/types/section';

type SectionListResponse = {
  sections: Required<Section[]>;
  next: (() => Promise<SectionListResponse | undefined>) | undefined;
};

export class SectionsClient {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandlerPublicAPI) {}

  fetchSections = async (
    cursor: string | null = null
  ): Promise<SectionListResponse | undefined> => {
    const { withErrorHandler, getResolvedError } = this.errorHandler;
    try {
      const { data } = await withErrorHandler(
        () => this.httpClient.request(listSections({ paging: { cursor } })),

        { errorCodesMap: {} }
      );
      const { hasNext, cursors } = data.pagingMetadata ?? {};
      return {
        sections: (data.sections || []) as Section[],
        next: hasNext ? this.fetchSections.bind(this, cursors?.next) : undefined,
      };
    } catch (e: unknown) {
      const error = getResolvedError(e);
      console.error(error);
      // return {};
    }
  };

  fetchAllSections = async () => {
    const sections = [];
    let response = await this.fetchSections();

    if (response) {
      sections.push(...response.sections);

      while (response?.next) {
        response = await response?.next();
        sections.push(...(response?.sections ?? []));
      }
    }
    return { sections };
  };

  getSectionById = async (sectionId: string) => {
    const { withErrorHandler, getResolvedError } = this.errorHandler;
    try {
      const { data } = await withErrorHandler(
        () => this.httpClient.request(getSection({ sectionId })),
        { errorCodesMap: {} }
      );
      return data;
    } catch (e: unknown) {
      const error = getResolvedError(e);
      console.error(error);
      return {};
    }
  };
}
